import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchBox } from 'react-instantsearch';
// Legacy posts feature: retained for backward compatibility with existing production data; remove once Records fully replace posts.
import './SearchBar.css';

const SearchBar = () => {
  const { t } = useTranslation();
  const { query, refine } = useSearchBox();
  const [inputValue, setInputValue] = useState(query);
  const [isComposing, setIsComposing] = useState(false);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    if (!isComposing) {
      refine(newValue);
    }
  };

  const handleCompositionStart = () => {
    setIsComposing(true);
  };

  const handleCompositionEnd = (e) => {
    setIsComposing(false);
    refine(e.target.value);
  };

  const handleClear = () => {
    setInputValue('');
    refine('');
  };

  return (
    <div className="search-bar">
      <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <input
        className="search-input"
        type="search"
        value={inputValue}
        onChange={handleChange}
        onCompositionStart={handleCompositionStart}
        onCompositionEnd={handleCompositionEnd}
        placeholder={t('search.placeholder')}
      />
      {inputValue && (
        <button className="search-clear" onClick={handleClear}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      )}
    </div>
  );
};

export default SearchBar;
